import React from 'react';
import { HiOutlineCheckCircle, HiOutlineCloudArrowUp } from "react-icons/hi2";

const ProfileStatusModal = ({ isUpdating, isSuccess }) => {
  return (
    <div className="bg-white rounded-[40px] p-10 shadow-2xl border border-slate-100 text-center relative overflow-hidden">
      
      {/* Decorative Background Glow */}
      <div className={`absolute -top-24 -left-24 w-48 h-48 rounded-full blur-3xl transition-colors duration-700 ${isSuccess ? 'bg-emerald-100' : 'bg-blue-100'}`} />

      <div className="relative z-10">
        {isUpdating && !isSuccess ? (
          <div className="flex flex-col items-center">
            {/* Pulsing Upload Icon */}
            <div className="relative mb-6">
              <div className="absolute inset-0 bg-blue-400 rounded-full animate-ping opacity-20"></div>
              <div className="bg-blue-600 p-5 rounded-3xl text-white shadow-xl shadow-blue-200">
                <HiOutlineCloudArrowUp size={40} className="animate-bounce" />
              </div>
            </div>
            <h3 className="text-2xl font-black text-slate-900 tracking-tight">Syncing Profile</h3>
            <p className="text-slate-500 font-medium mt-2">Uploading your changes to the cloud...</p>
            
            {/* Simple Progress Bar Animation */}
            <div className="w-48 h-1.5 bg-slate-100 rounded-full mt-8 overflow-hidden">
              <div className="h-full bg-blue-600 rounded-full animate-[progress_2s_ease-in-out_infinite]" 
                   style={{ width: '40%' }}></div>
            </div>
          </div>
        ) : (
          <div className="flex flex-col items-center animate-in zoom-in-90 duration-300">
            {/* Success Tick */}
            <div className="bg-emerald-500 p-5 rounded-full text-white shadow-xl shadow-emerald-200 mb-6">
              <HiOutlineCheckCircle size={48} />
            </div>
            <h3 className="text-2xl font-black text-slate-900 tracking-tight">Profile Updated!</h3>
            <p className="text-emerald-600 font-bold mt-2">Everything looks great.</p>
            
            <div className="mt-8 flex items-center gap-2 text-slate-400 text-xs font-bold uppercase tracking-widest">
               <span className="inline-block w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></span>
               Closing Automatically
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfileStatusModal;